import React from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import svodMessages from '../../locales/svod';
import {
	toggleVolume,
	displayDropdown,
	removeDropdown,
	updateWatchlist,
	newActiveVideo,
	removeActiveVideo,
	setPreviousSelectedAsset,
	setSelectedAsset,
	setSelectedAssetRow
} from '../../redux/actions/SVOD';
import VideoPlayer from './video-player';
import { returnTimeInSVOD, isSVODTargetAsset } from '../../functions/utils';
import {
	EnvType,
	SVOD_ASSET_NAVIGATION,
	APPLETV_PLUS_ASSET_ENTRY
} from "./constants";

import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';

class ThumbnailItem extends React.Component {
	constructor(props) {
		super(props);

		this.video = this.props.video;
		this.label = this.props.label;
		this.idx = this.props.idx;

		this.row_type = this.props.row_type; // AppleTV: coming_soon, latest_release

		this.state = {
			volume: this.props.volume.volume,
			active: false,
			watchlistRemoved: false,
			timeIn: '',
			timeOut: '',
			displayTooltip: false,
			imageLoaded: false,
		};

		this.backgroundFadeInterval = {};
		this.displayDropdown = this.props.displayDropdown;
		this.removeDropdown = this.props.removeDropdown;
		this.dropdown = this.props.dropdown;

		this.upVolume = this.upVolume.bind(this);
		this.downVolume = this.downVolume.bind(this);
		this.mouseEnter = this.mouseEnter.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.updateWatchlist = this.updateWatchlist.bind(this);
		this.upRate = this.upRate.bind(this);
		this.downRate = this.downRate.bind(this);
		this.triggerReport = this.triggerReport.bind(this);
		this.triggerThumbnailClickEvent = this.triggerThumbnailClickEvent.bind(this);
		this.selectAsset = this.selectAsset.bind(this);
		this.setImageFadeInInterval = this.setImageFadeInInterval.bind(this);
	}

	componentDidMount() {
		this.setImageFadeInInterval();
	}

	setImageFadeInInterval() {
		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.imageLoaded && this.video) {
				let img = document.getElementById(`${this.props.label}-${this.video._id.valueOf()}-img`);
				if (img && img.complete) {
					img.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);
	}

	componentWillUnmount() {
		if (this.backgroundFadeInterval) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	handleOpen(e) {
		this.props.eventHandler({
			data: {
				event_type: "opened_dropdown",
				type: "asset_details_dropdown",
				action: "opened_dropdown",
				asset_id: this.video._id.valueOf(),
				time: Date.now()
			}
		});

		let payload = {
			video: this.video,
			label: this.label
		};

		this.props.newActiveVideo("dropdown");
		this.setState({ active: false });
		this.displayDropdown(payload);

		let oldSelected = document.getElementsByClassName("selected-vid")[0];
		if (oldSelected !== undefined) {
			oldSelected.classList.remove("selected-vid");
		}

		let newSelected = document.getElementById(`video-${this.label}-${this.idx}`);
		newSelected.classList.add("selected-vid");
	}

	videoEnded() {
		this.setState({ active: false });
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.imageLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}

		if (this.video
			&& this.props.video
			&& this.video._id !== this.props.video._id
		) {
			this.video = this.props.video;
			this.setImageFadeInInterval();
			this.setState({ imageLoaded: false });
		}

		if (prevState.timeOut !== this.state.timeOut) {
			if (this.state.timeOut - this.state.timeIn > 3000) {
				this.props.eventHandler({
					data: {
						event_type: "time_interacted_with",
						type: "tile",
						action: "end_time",
						asset_id: this.video._id.valueOf(),
						start_time: this.state.timeIn,
						end_time: this.state.timeOut
					}
				});
			}
		}

		if (!prevState.displayTooltip && this.state.displayTooltip) {
			let tooltip = document.getElementById("disabled-asset-tooltip");
			setTimeout(() => tooltip.style.opacity = 0, 1000);
		}
	}

	upVolume(e) {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'FALSE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		e.stopPropagation();

		this.videoElement.updateVideoPlayer("volume", true);
		this.setState({ volume: true });
	}

	downVolume(e) {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'TRUE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		e.stopPropagation();

		this.videoElement.updateVideoPlayer("volume", false);
		this.setState({ volume: false });
	}

	mouseEnter(hoveredAsset) {
		const {
			environment,
			dropdown,
			watchlist_video,
			onMouseEnter,
			magnifyDisabled,
		} = this.props;
		if (!onMouseEnter && dropdown.video === undefined) {
			if (!watchlist_video) {
				if (!this.state.active && !magnifyDisabled) {
					switch (environment) {
						case EnvType.NETFLIX: {
							// Handles the zoom in effect on thumbnail items for netflix
							let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
							for (let i = 0; i < vidsInRow.length; i++) {

								if (i < this.idx) {
									let vid = vidsInRow[i];
									let oldTransform = vid.style.transform;
									vid.style.transform = `${oldTransform} translate3d(-45px, 0, 0)`;
								} else if (i > this.idx) {
									let vid = vidsInRow[i];
									let oldTransform = vid.style.transform;
									vid.style.transform = `${oldTransform} translate3d(45px, 0, 0)`;
								} else {
									let vid = vidsInRow[i];
									let oldTransform = vid.style.transform;
									vid.style.transform = `${oldTransform} scale(1.3)`;
								}
							}
							break;
						}
						case EnvType.AMAZON: {
							let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
							for (let i = 0; i < vidsInRow.length; i++) {
								if (i === this.idx) {
									let vid = vidsInRow[i];
									let oldTransform = vid.style.transform;
									vid.style.transform = `${oldTransform} scale(1.1) translateY(65px)`;
								}
							}
							break;
						}
						case EnvType.PEACOCK: {
							if (!this.props.disabledAsset) {
								let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
								for (let i = 0; i < vidsInRow.length; i++) {
									if (i === this.idx && !this.props.disabledAsset) {
										let vid = vidsInRow[i];
										let oldTransform = vid.style.transform;
										vid.style.transform = `${oldTransform} scale(1.05)`;
									}
								}
							}
							this.props.handleBillboardAsset(hoveredAsset);
							break;
						}
						case EnvType.APPLETV: {
							let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
							let excludedNode = 0;
							for (let nodeIndex = 0; nodeIndex < vidsInRow.length; nodeIndex++) {
								const vid = vidsInRow[nodeIndex];

								if (vid.className.includes('included-apple-tv-thumbnail')) {
									excludedNode++;
								}

								if ((nodeIndex - excludedNode) === this.idx && !this.props.disabledAsset) {
									let oldTransform = vid.style.transform;
									vid.style.transform = `${oldTransform} scale(1.05)`;
								}
							}
							break;
						}
					}
				}

				this.setState({ active: true });
			}
			else {
				switch (environment) {
					case EnvType.AMAZON: {
						let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
						let vid = vidsInRow[this.idx];
						vid.style.transform = `scale(1.1)`;
					}
				}
			}

			this.props.newActiveVideo("thumbnail");

			this.setState({ timeIn: Date.now(), volume: this.props.volume.volume });
		}
	}

	mouseLeave() {
		const {
			dropdown,
			environment,
			watchlist_video,
		} = this.props;

		if (dropdown.video === undefined) {
			if (!watchlist_video) {
				if (this.state.active) {
					// Handles the zoom out effect on thumbnail items
					let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
					for (let i = 0; i < vidsInRow.length; i++) {
						let vid = vidsInRow[i];
						let oldTransform = vid.style.transform.split(")");
						let newTransform = '';

						if (oldTransform[0].includes("translateX")) {
							newTransform += oldTransform[0] + ")";
						}

						vid.style.transform = newTransform;
					}
				}
			} else {

				switch (environment) {
					case EnvType.AMAZON:
					case EnvType.PEACOCK:
					case EnvType.APPLETV: {
						if (!this.props.disabledAsset) {
							let vidsInRow = document.getElementsByClassName(`videoItem-${this.label}`);
							let vid = vidsInRow[this.idx];
							vid.style.transform = ``;
						}
						break;
					}
				}
			}

			if (this.state.active) {
				this.props.toggleVolume(this.state.volume);
			}
			this.props.removeActiveVideo();
		}
		this.setState({ active: false, timeOut: Date.now(), displayTooltip: false });
	}

	updateWatchlist() {
		if (this.props.watchlist.includes(this.video._id.valueOf())) {
			this.props.eventHandler({
				data: {
					event_type: "watchlist",
					action: "removed_from_watchlist",
					type: "tile",
					asset_id: this.video._id.valueOf(),
					time: Date.now()
				}
			});

			let newWatchlist = this.props.watchlist.filter((value) => { return value !== this.video._id.valueOf(); });
			this.props.updateWatchlist(newWatchlist);
			if (this.props.watchlist_video) {
				this.setState({ watchlistRemoved: true });
			}
		} else {
			this.props.eventHandler({
				data: {
					event_type: "watchlist",
					action: "added_to_watchlist",
					type: "tile",
					asset_id: this.video._id.valueOf(),
					time: Date.now()
				}
			});
			let newWatchlist = [...this.props.watchlist, this.video._id.valueOf()];
			this.props.updateWatchlist(newWatchlist);
		}
	}

	upRate() {
		this.props.eventHandler({
			data: {
				event_type: "rating",
				type: "tile",
				action: "like",
				asset_id: this.video._id.valueOf(),
				time: Date.now()
			}
		});

		let buttons = document.getElementsByClassName(`$hover-rating-${this.video._id.valueOf()}`);
		buttons[1].style.color = "white";
		buttons[1].style.borderColor = "white";
		buttons[0].style.color = "green";
		buttons[0].style.borderColor = "green";
	}

	downRate() {
		this.props.eventHandler({
			data: {
				event_type: "rating",
				type: "tile",
				action: "dislike",
				asset_id: this.video._id.valueOf(),
				time: Date.now()
			}
		});

		let buttons = document.getElementsByClassName(`$hover-rating-${this.video._id.valueOf()}`);
		buttons[0].style.color = "white";
		buttons[0].style.borderColor = "white";
		buttons[1].style.color = 'red';
		buttons[1].style.borderColor = 'red';
	}

	triggerReport() {
		this.props.eventHandler({
			data: {
				event_type: "asset_fullscreen_playback",
				type: "tile",
				action: "asset_fullscreen_playback",
				asset_id: this.video._id.valueOf(),
				time: Date.now()
			}
		});
	}

	selectAsset(asset) {
		const {
			selectedAsset,
			label,
			targetAssets,
			svodStartTime,
			totalModalTime,
			handleSVODPanelResponses,
			setPreviousSelectedAsset,
			setSelectedAsset,
			setSelectedAssetRow,
		} = this.props;

		setPreviousSelectedAsset(selectedAsset);
		setSelectedAsset(asset);
		setSelectedAssetRow(label);

		const identifier = isSVODTargetAsset(asset, targetAssets) || asset.original_theme
			? asset._id
			: asset.licensed ? 'licensed' : asset.transactional ? 'transaction' : '';
		const submittedAnswer = returnTimeInSVOD(svodStartTime, totalModalTime);

		if (svodStartTime && (asset.licensed || asset.transactional)) {
			const submittedSVODKey = `${APPLETV_PLUS_ASSET_ENTRY}-${identifier}`;
			handleSVODPanelResponses(submittedAnswer, submittedSVODKey, identifier, APPLETV_PLUS_ASSET_ENTRY);
		}

		if (svodStartTime && asset && (isSVODTargetAsset(asset, targetAssets) || asset.original_theme)) {
			const submittedSVODKey = `${SVOD_ASSET_NAVIGATION}-${identifier}`;
			handleSVODPanelResponses(submittedAnswer, submittedSVODKey, identifier, SVOD_ASSET_NAVIGATION);
		}
	}

	handleThumbnailClick() {
		let rowTitle = (this.props.label.split("_")[0]);
		let rowId = (this.props.label.split("_")[1]);

		this.props.eventHandler({
			data: {
				event_type: "thumbnail_click",
				type: "disabled_asset_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				row_id: rowId,
				row_name: rowTitle,
				page_location: this.props.page_location,
				source_asset_name: this.props.source_asset_name,
				source_asset_id: this.props.source_asset_id,
				time: Date.now()
			}
		});

		if (this.props.disabledAsset && !this.state.displayTooltip) {
			this.setState({ displayTooltip: true });
		}
	}

	triggerThumbnailClickEvent() {
		const { label, billboardLabel } = this.props;
		const thumbnailLabel = billboardLabel || label;
		const rowTitle = (thumbnailLabel.split("_")[0]);
		const rowId = (thumbnailLabel.split("_")[1]);

		this.props.eventHandler({
			data: {
				event_type: "thumbnail_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				row_id: rowId,
				row_name: rowTitle,
				page_location: this.props.page_location,
				source_asset_name: this.props.source_asset_name,
				source_asset_id: this.props.source_asset_id,
				time: Date.now()
			}
		});
	}

	render() {
		const {
			watchlist_video,
			activeVideo,
			environment,
			watchlist,
			isSurveyActive,
			video,
			label,
			disabledAsset,
			isDynamicBillboard,
			activeBillboard,
			onClick
		} = this.props;

		let volumeButton = (!watchlist_video && activeVideo === "thumbnail") ? (
			(this.state.volume) ? (
				<button className="hover-buttons-volume" id="thumbnail-volume" onClick={this.downVolume}><i className="fas fa-volume-up"></i></button>
			) : (
				<button className="hover-buttons-volume" id="thumbnail-volume" onClick={this.upVolume}><i className="fas fa-volume-off"></i></button>
			)
		) : (
			<span></span>
		);

		let watchlist_class = (environment === EnvType.AMAZON) ? (
			"amazon-watchlist-button"
		) : (
			"hover-buttons-watchlist"
		);

		let watchlistButton = (watchlist.includes(this.video._id.valueOf())) ? (
			<button onClick={this.updateWatchlist} className={watchlist_class} id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-check"></i></button>
		) : (
			<button onClick={this.updateWatchlist} className={watchlist_class} id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-plus"></i></button>
		);

		let content = (watchlist_video) ? (
			(this.state.watchlistRemoved) ? (
				<div className="removed-thumbnail-div">
					<img className="thumbnail-pic watchlist-removed" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} />
					<p>{this.props.intl.formatMessage(svodMessages.removed_from_watchlist)}</p>
				</div>
			) : (
				<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} />
			)
		) : (
			(this.state.active && !isSurveyActive && activeVideo === "thumbnail") ? (
				<VideoPlayer location="TILEVIDEO" className="thumbnail-video-player" onRef={ref => this.videoElement = ref} videoEnded={this.videoEnded} id="hover-video" video={this.video} watchpage={false} {...this.props} />
			) : (
				<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} loading="lazy" />
			)
		);

		let mpaa = (this.video.content.mpaa === undefined) ? (
			<span></span>
		) : (
			<span id="rating">{this.video.content.mpaa.label}</span>
		);

		let season = (this.video.season_num) ? (
			<span>
				<p>{this.props.intl.formatMessage(svodMessages.season_initial)}:{this.video.season_num}</p>
			</span>
		) : (
			<span></span>
		);

		let episode = (this.video.episode_num) ? (
			<span>
				<p>{this.props.intl.formatMessage(svodMessages.episode_initial)}:{this.video.episode_num}</p>
			</span>
		) : (
			<span></span>
		);

		let year = (this.video.content.year) ? (
			<span>
				<p>{this.video.content.year}</p>
			</span>
		) : (
			<span></span>
		);

		let rating = (this.video.rating) ? (
			<span>
				<p>{this.props.intl.formatMessage(svodMessages.rating)}: {this.video.rating * 100}%</p>
			</span>
		) : (<span></span>);

		let genres = this.video.content.genres ? (
			this.video.content.genres.map((genre, idx) => {
				return (
					<span className="details-genre" key={`details-genres-${this.video._id}`}>{genre}</span>
				);
			})
		) : [];

		switch (environment) {
			case EnvType.PEACOCK: {
				if (isDynamicBillboard) {
					return <span
						onClick={onClick}
						className={activeBillboard ? "active dynamic-thumbnail" : "dynamic-thumbnail"}>·</span>;
				}
				let peacockSeason;
				if (this.video.season_num) {
					if (this.video.season_num > 1) {
						peacockSeason = `${this.video.season_num} ${this.props.intl.formatMessage(svodMessages.seasons)}`;
					} else {
						peacockSeason = `${this.video.season_num} ${this.props.intl.formatMessage(svodMessages.season)}`;
					}
				}

				let peacockInfo = [];
				if (this.video.rating) {
					peacockInfo.push(<p>{this.video.rating * 100}%</p>);
				}
				if (genres) {
					peacockInfo.push(<p>{genres[0]}</p>);
				}
				if (this.video.content.year) {
					peacockInfo.push(<p>{this.video.content.year}</p>);
				}
				if (peacockSeason) {
					peacockInfo.push(<p>{peacockSeason}</p>);
				}

				let peacockTotalList = [];
				peacockInfo.forEach(item => {
					peacockTotalList.push(item);
					peacockTotalList.push(<span className="divider-dot">•</span>);
				});
				peacockTotalList.pop();

				let peacockTotalInfoListed = peacockTotalList.map((item, idx) => {
					return (
						<span key={idx}>{item}</span>
					);
				});

				const borderClass = this.props.billboardAsset
					&& this.props.billboardAsset._id
					&& this.props.video
					&& this.props.video._id
					&& this.props.video._id.includes(this.props.billboardAsset._id)
					? " thumbnail-border"
					: "";


				return (
					<span
						id={`video-${this.label}-${this.idx}`}
						className={`videoItem-${label} index-item ${disabledAsset ? "disabled-asset" : ""} ${this.row_type}${borderClass}`}
						onMouseEnter={() => this.mouseEnter(video)}
						onMouseLeave={this.mouseLeave}
						onClick={this.triggerThumbnailClickEvent}
					>
						{this.state.displayTooltip && (
							<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
						)}
						{disabledAsset && (
							<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
						)}
						<span className="thumbnail-container-peacock" onClick={() => this.selectAsset(video)}>
							<div className="image-container">
								<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} loading="lazy" />
							</div>
							<Link to="/study/showpage" id={this.video._id}>
								<div className="hover-buttons">
									<p className="item-title">{this.video.content.title}</p>
									<div className="item-info">
										{peacockTotalInfoListed}
									</div>
								</div>
							</Link>
						</span>
					</span>
				);
			}
			case EnvType.AMAZON: {
				return (
					<span className={`videoItem-${label} index-item ${disabledAsset ? "disabled-asset" : ""} ${this.row_type}`} id={`video-${this.label}-${this.idx}`} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} onClick={this.triggerThumbnailClickEvent}>
						{this.state.displayTooltip && (
							<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
						)}
						{disabledAsset && (
							<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
						)}
						<span className="thumbnail-container-amazon" onClick={() => this.selectAsset(video)}>

							<div className="image-container" onClick={this.handleOpen} >
								<div className="cover-video">
									{volumeButton}
								</div>
								{content}
							</div>

							<div className={(watchlist_video) ? ("hover-buttons-amazon-watchlist") : ("hover-buttons-amazon")}>

								<div className="amazon-thumbnail-items">
									<div className="amazon-play-watchlist-buttons">
										<span className="amazon-play">
											<Link to="/study/watch" onClick={this.triggerReport}>
												<button className="hover-buttons-play"><i className="fas fa-play" /></button>
											</Link>
											<span className="amazon-play-text"><p className="amazon-play-play-text">{this.props.intl.formatMessage(svodMessages.play)}</p> {season}</span>
										</span>
										{watchlistButton}
									</div>

									<div className="amazon-thumbnail-content" >
										<p className="item-title">{this.video.content.title}</p>
										<p>{this.video.content.logline}</p>
									</div>

									<div className="item-info">
										{rating}
										{year}
										{mpaa}
									</div>

								</div>
							</div>
						</span>
					</span>
				);
			}
			case EnvType.NETFLIX: {
				return (
					<span className={`videoItem-${label} index-item ${disabledAsset ? "disabled-asset" : ""} ${this.row_type}`} id={`video-${this.label}-${this.idx}`} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} onClick={this.triggerThumbnailClickEvent}>
						{this.state.displayTooltip && (
							<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
						)}
						{disabledAsset && (
							<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
						)}
						<span className="thumbnail-container-netflix" onClick={() => this.selectAsset(video)}>
							<div className="image-container">
								{content}
							</div>
							<div className="hover-buttons">
								<div className="item-left">

									<div className="left-items-thumbnail">
										<Link to="/study/watch" onClick={this.triggerReport}>
											<button className="hover-buttons-play"><i className="fas fa-play" /></button>
										</Link>
										<p className="item-title">{this.video.content.title}</p>
										<div className="item-info">
											{mpaa}
											{season} {episode}
										</div>
									</div>

									<div className="item-right">
										{volumeButton}
										<button onClick={this.upRate} className={`$hover-rating-${this.video._id.valueOf()} hover-buttons-rating`}><i className="fas fa-thumbs-up"></i></button>
										<button onClick={this.downRate} className={`$hover-rating-${this.video._id.valueOf()} hover-buttons-rating`}><i className="fas fa-thumbs-down"></i></button>
										{watchlistButton}
									</div>

									<button className="hover-buttons-dropdown" onClick={this.handleOpen}><i className="fas fa-chevron-down" /></button>

								</div>
							</div>
						</span>
					</span>
				);
			}
			case EnvType.APPLETV: {
				let thumbnailLink = "/study/showpage";
				if (this.props.destination === "watchpage") {
					thumbnailLink = "/study/watch";
				} else if (this.video.transactional) {
					thumbnailLink = "/study/transaction";
				}

				if (this.row_type === "coming_soon") {
					return (
						<span className={`${this.video._id} videoItem-${this.props.addedClass ? this.props.addedClass + '-' : ''}${label} index-item ${disabledAsset ? "disabled-asset" : ""} ${this.row_type}`} id={`video-${this.label}-${this.idx}`} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} onClick={this.triggerThumbnailClickEvent}>
							{this.state.displayTooltip && (
								<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
							)}
							{disabledAsset && (
								<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
							)}
							<span className="thumbnail-container-appletv" onClick={() => this.selectAsset(video)}>
								<Link to={thumbnailLink} id={this.video._id}>
									<div className="image-container">
										<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} />
									</div>
								</Link>
							</span>
						</span>
					);
				}
				else if (this.row_type === "latest_releases") {
					return (
						<span className={`${this.video._id} videoItem-${this.props.addedClass ? this.props.addedClass + '-' : ''}${label} index-item ${disabledAsset ? "disabled-asset" : ""}`} id={`video-${this.label}-${this.idx}`} onClick={this.triggerThumbnailClickEvent}>
							{this.state.displayTooltip && (
								<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
							)}
							{disabledAsset && (
								<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
							)}
							<span className={`thumbnail-container-appletv latest_releases-tile-image-${label}`} onClick={() => this.selectAsset(video)}>
								<Link to={thumbnailLink} id={this.video._id}>
									<div className="image-container">
										<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} />
									</div>
								</Link>
							</span>
							<div className="metadata">
								<div className="genre" >{this.video.content.genres ? this.video.content.genres[0] : ""}</div>
								<div className="title" >{this.video.content.title ? this.video.content.title : ""}</div>
								<div className="logline" >{this.video.content.description ? this.video.content.description : ""}</div>
							</div>
						</span>
					);
				}
				else {
					const thumbnailLabel = this.props.billboardLabel || this.props.label;
					let disabledOriginalThemeAsset = this.props.disabledAsset && video.original_theme;

					return (
						<span id={`video-${this.label}-${this.idx}`}
							className={`${this.video._id} videoItem-${this.props.addedClass ? this.props.addedClass + '-' : ''}${thumbnailLabel} index-item ${disabledAsset ? "disabled-asset" : ""} ${this.row_type} ${activeBillboard ? "active-billboard-thumbnail" : ""} ${disabledOriginalThemeAsset ? "opacity-0p" : ""}`}
							onMouseEnter={this.mouseEnter}
							onMouseLeave={this.mouseLeave}
							onClick={this.triggerThumbnailClickEvent}>
							{this.state.displayTooltip && (
								<div className="disabled-asset-tooltip" id="disabled-asset-tooltip">{this.props.intl.formatMessage(svodMessages.not_available)}</div>
							)}
							{disabledAsset && (
								<div className="disabled-asset-select" onClick={this.handleThumbnailClick}></div>
							)}
							<span className={`${isDynamicBillboard ? `dynamic-thumbnail` : ''} thumbnail-container-appletv`} onClick={() => this.selectAsset(video)}>
								<Link to={thumbnailLink} id={this.video._id}>
									<div className="image-container">
										<img className="thumbnail-pic" id={`${label}-${this.video._id.valueOf()}-img`} src={this.video.images.thumbnail} />
									</div>
								</Link>
								{isDynamicBillboard ? '' : <p className="item-title">{this.video.content.title}</p>}
							</span>
						</span>
					);
				}
			}
		}
	}
}


const mapStateToProps = (state) => ({
	selectedAssetRow: state.SVOD.selectedAssets.assetRow,
	selectedAsset: state.SVOD.selectedAssets.asset,
	previousSelectedAsset: state.SVOD.selectedAssets.previousAsset,
	dropdown: state.SVOD.dropdown,
	activeVideo: state.SVOD.activeVideo,
	watchlist: state.SVOD.watchlist,
	volume: state.SVOD.volume,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	environment: state.SVOD.environment,
	isSurveyActive: state.SVOD.isSurveyActive,
	targetAssetId: state.SVOD.selectedAssets.targetAssetId,
});

const mapDispatchToProps = (dispatch) => ({
	displayDropdown: (payload) => dispatch(displayDropdown(payload)),
	removeDropdown: () => dispatch(removeDropdown()),
	newActiveVideo: (payload) => dispatch(newActiveVideo(payload)),
	removeActiveVideo: () => dispatch(removeActiveVideo()),
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	setPreviousSelectedAsset: (asset) => dispatch(setPreviousSelectedAsset(asset)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(injectIntl(ThumbnailItem));


// WEBPACK FOOTER //
// ./src/components/svod/thumbnail-item.jsx